import hero from "@/assets/hero.jpg";
import { Header } from "@/components/header";
import { Brand } from "@/components/brand";

// Public pages (login, register, forgot password): form column + hero panel on desktop.
export function AuthLayout({ title, subtitle, testID, children }) {
  return (
    <div data-testid={testID} className="min-h-screen bg-[#121212] lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      <aside className="relative hidden overflow-hidden lg:block">
        <img src={hero} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#121212]/40 via-[#121212]/70 to-[#121212]" />
        <div className="relative flex h-full flex-col justify-between p-10">
          <Brand />
          <div className="max-w-md">
            <p className="t-display">Plateforme nationale de recommandations immobilières</p>
            <p className="t-body mt-3 !text-[#C0C0C0]">Recommandez, suivez chaque dossier jusqu'à la signature et touchez vos commissions.</p>
          </div>
        </div>
      </aside>
      <div className="flex min-h-screen flex-col">
        <Header title={title} subtitle={subtitle} />
        <div className="mx-auto flex w-full max-w-xl flex-col gap-4 p-6 pb-10 md:p-10 fade-up">{children}</div>
      </div>
    </div>
  );
}
